import api from '@/services/api';
import { PaginatedResponse } from '@/types/common';
import { Topic } from '@/types/topics';

export const topicsService = {
  async getAll(): Promise<PaginatedResponse<Topic>> {
    const response = await api.get<PaginatedResponse<Topic>>('/topics?offset=0&limit=1000');
    return response.data;
  },
};
